import React from 'react';
import PropTypes from 'prop-types';

/**
 * IFrame iframe block
 * @class IFrame
 * @extends Component
 */

const IFrame = ({ data, block }) => {
  let width = data?.iframe_width ?? '100%';
  let height = data?.iframe_height ?? 'auto';
  let aspectRatio = data?.iframe_aspect_ratio ?? '16:9';
  if (data.iframe_width && data.iframe_height) {
    aspectRatio = null;
  } else {
    aspectRatio = aspectRatio.replace(':', '/');
  }

  const style = aspectRatio ? (
    <style type="text/css">{`#iframe${block}{aspect-ratio: ${aspectRatio};}`}</style>
  ) : (
    <></>
  );

  return data?.iframe_href ? (
    <>
      {style}
      <iframe
        id={'iframe' + block}
        src={data.iframe_href}
        width={width}
        height={height}
        //style={{ aspectRatio: aspectRatio }}
        frameBorder="0"
        marginWidth="0"
        marginHeight="0"
        allowtransparency="true"
        allowFullScreen={true}
      ></iframe>
    </>
  ) : (
    <></>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */

IFrame.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default IFrame;
